import { container } from '@eureka/services/src/container';

export const getLegalApi = () => {
    return container.AnalyticsHttp.get({
        url: `${import.meta.env.VITE_CORE_BASIC_SERVICE_URI}/core-basic-api/analytics/config/legal-status`,
        cache: true,
    }).then(({ data }) => {
        return data
    })
}
